import {BalloonEventModel} from "ts-core";
import {Badge, dateCountDown, useTranslations} from "react-ui";
import React from "react";

export interface CountdownBadgeProps {
    event: BalloonEventModel
    className?: string
}

export const CountdownBadge: React.FC<CountdownBadgeProps> = ({event, className}: CountdownBadgeProps) => {
    const { translated } = useTranslations();
    return <div className={`coundown-badge ${className}`}>
        <Badge color="white">
            <span className="coundown-badge-content text-black mr-0 px-0 py-0 font-semibold text-xs  flex items-center justify-center text-center flex-row">
                {dateCountDown(event.latestDate, translated)}
                <i className="fa fa-bell-o ml-1 font-semibold text-black"></i>
            </span>
        </Badge>
    </div>
}